import styled from 'styled-components';

export const TitleText = styled.h2<{
  color?: string;
  textAlign?: string;
}>`
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size40};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  padding-bottom: 0;
  text-align: ${({ textAlign }) => textAlign || 'left'};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size32};
  }
`;

export const TextWrapper = styled.div<{ textAlign?: string }>`
  width: 43rem;
  font-size: ${({ theme }) => theme.fontSize.size22};
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size22};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  text-align: ${({ textAlign }) => textAlign || 'left'};
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 100%;
    font-size: ${({ theme }) => theme.fontSize.size18};
  }
`;

export const TextSection = styled.div`
  padding: 1.5rem 0;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 1rem 0 rem;
  }
`;

export const ContentWrapper = styled.div<{ padding?: string }>`
  padding-bottom: ${({ padding }) => padding || '0'};
`;

export const DividerWrapper = styled.div<{ justifyContent: string }>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'start'};
  margin-top: 1.625rem;
`;

export const ButtonWrapper = styled.div<{
  justifyContent: string;
}>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'start'};
  margin-top: 3rem;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const SubtitleWrapper = styled.div<{
  $isQuestionPage?: boolean;
}>`
  margin-top: 3rem;
`;
